// import CalendarTodayIcon from '@mui/icons-material/CalendarMonth'
// import { LoadingButton } from '@mui/lab'
// import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, TextField } from '@mui/material'
// import { ExplanationAccordion } from 'components'
// import { VehicleDto } from 'dtos'
// import { Formik } from 'formik'
// import { ChangeEvent, useState } from 'react'
// import { useNavigate } from 'react-router-dom'

// interface TirePressureLabelEditDialogProps {
//   initialValues: VehicleDto
//   open: boolean
//   onClose: () => void
//   onSave: (values: any) => void
//   isLoading: boolean
// }

// export default function TirePressureLabelEditDialog({
//   open,
//   onClose,
//   onSave,
//   isLoading,
//   initialValues
// }: TirePressureLabelEditDialogProps) {
//   const navigate = useNavigate()
//   const [value, setValue] = useState<string>('vehicle-details')
//   const [language, setLanguage] = useState<string[]>([])
//   const [selectedType, setSelectedType] = useState<string>('')
//   const [selectedUnit, setSelectedUnit] = useState<string>('kg')
//   const [isCheckingVIN, setIsCheckingVIN] = useState<boolean>(false)
//   const [isOldVehicle, setIsOldVehicle] = useState<boolean>(false)
//   const [isSavingExporterNote, setIsSavingExporterNote] = useState<boolean>(false)
//   const handleTypeChange = (event: ChangeEvent<{ value: unknown }>) => {
//     setSelectedType(event.target.value as string)
//   }
//   const handleUnitChange = (event: ChangeEvent<HTMLInputElement>) => {
//     setSelectedUnit(event.target.value)
//   }
//   const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
//     setIsOldVehicle(event.target.checked)
//   }
//   const [exporterNoteAddEditDialogOpen, setExporterNoteAddEditDialogOpen] = useState<boolean>(false)

//   return (
//     <Dialog open={open} onClose={onClose}>
//       <Formik
//         enableReinitialize={true}
//         initialValues={initialValues}
//         validateOnChange={true}
//         validateOnBlur={false}
//         validationSchema={{}}
//         onSubmit={() => {
//           setIsSavingExporterNote(false)
//         }}
//       >
//         {({ errors, handleBlur, handleChange, handleSubmit, isSubmitting, setFieldValue, touched, values }) => {
//           return (
//             <form onSubmit={handleSubmit}>
//               <DialogContent>
//                 <Grid container spacing={2} alignItems='center'>
//                   <DialogTitle>Tire Pressure Label</DialogTitle>

//                   <Grid item xs={12}>
//                     <TextField
//                       fullWidth
//                       label='Tire Pressure Label Ordered'
//                       placeholder=''
//                       InputProps={{
//                         endAdornment: (
//                           <IconButton>
//                             <CalendarTodayIcon />
//                           </IconButton>
//                         )
//                       }}
//                     />
//                   </Grid>

//                   <Grid item xs={12}>
//                     <TextField
//                       fullWidth
//                       label='Tire Pressure Label Received'
//                       placeholder=''
//                       InputProps={{
//                         endAdornment: (
//                           <IconButton>
//                             <CalendarTodayIcon />
//                           </IconButton>
//                         )
//                       }}
//                     />
//                   </Grid>
//                 </Grid>
//                 <Grid item xs={12} sx={{ mt: 2 }}>
//                   <ExplanationAccordion>Neither field is pre-populated nor required to save.</ExplanationAccordion>
//                 </Grid>
//               </DialogContent>

//               <DialogActions>
//                 <Button color='inherit' onClick={onClose} variant='text'>
//                   CANCEL
//                 </Button>

//                 <LoadingButton color='primary' onClick={onClose} type='submit' variant='contained'>
//                   <span>{'Save'}</span>
//                 </LoadingButton>
//               </DialogActions>
//             </form>
//           )
//         }}
//       </Formik>
//     </Dialog>
//   )
// }

import { LoadingButton } from '@mui/lab'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid } from '@mui/material'
import { DatePicker } from '@mui/x-date-pickers'
import { ExplanationAccordion } from 'components'
import { VehicleCheckInTirePressureLabelDatesDto, vehicleCheckInTirePressureLabelDatesValidationSchema } from 'dtos'
import { Formik } from 'formik'
import moment from 'moment'

interface TirePressureLabelEditDialogProps {
  initialValues: VehicleCheckInTirePressureLabelDatesDto
  open: boolean
  onClose: () => void
  onSave: (values: any) => void
  isLoading: boolean
}

export default function TirePressureLabelEditDialog({
  open,
  onClose,
  onSave,
  isLoading,
  initialValues
}: TirePressureLabelEditDialogProps) {
  return (
    <Dialog open={open} onClose={onClose}>
      <Formik
        enableReinitialize={true}
        initialValues={initialValues}
        validateOnChange={true}
        validateOnBlur={false}
        validationSchema={vehicleCheckInTirePressureLabelDatesValidationSchema}
        onSubmit={(values, formikHelpers) => {
          onSave(values)
          formikHelpers.setSubmitting(false)
        }}
      >
        {({ errors, handleBlur, handleChange, handleSubmit, isSubmitting, setFieldValue, touched, values }) => (
          <form onSubmit={handleSubmit}>
            <DialogTitle>Tire Pressure Label</DialogTitle>
            <DialogContent>
              <Grid container spacing={2} alignItems='center'>
                <Grid item xs={12} mt={2}>
                  <DatePicker
                    disabled={isLoading || isSubmitting}
                    label='Tire Pressure Label Ordered'
                    onChange={newValue => {
                      if (newValue) {
                        setFieldValue('tirePressureLabelOrderedDate', newValue.format('yyyy-MM-DD'))
                      } else {
                        setFieldValue('tirePressureLabelOrderedDate', undefined)
                      }
                    }}
                    slotProps={{
                      actionBar: {
                        actions: ['clear']
                      },
                      textField: {
                        error: Boolean(touched.tirePressureLabelOrderedDate && errors.tirePressureLabelOrderedDate),
                        helperText: touched.tirePressureLabelOrderedDate && errors.tirePressureLabelOrderedDate
                      }
                    }}
                    value={values.tirePressureLabelOrderedDate ? moment(values.tirePressureLabelOrderedDate) : null}
                  />
                </Grid>

                <Grid item xs={12}>
                  <DatePicker
                    disabled={isLoading || isSubmitting}
                    label='Tire Pressure Label Received'
                    onChange={newValue => {
                      if (newValue) {
                        setFieldValue('tirePressureLabelReceivedDate', newValue.format('yyyy-MM-DD'))
                      } else {
                        setFieldValue('tirePressureLabelReceivedDate', undefined)
                      }
                    }}
                    slotProps={{
                      actionBar: {
                        actions: ['clear']
                      },
                      textField: {
                        error: Boolean(touched.tirePressureLabelReceivedDate && errors.tirePressureLabelReceivedDate),
                        helperText: touched.tirePressureLabelReceivedDate && errors.tirePressureLabelReceivedDate
                      }
                    }}
                    value={values.tirePressureLabelReceivedDate ? moment(values.tirePressureLabelReceivedDate) : null}
                  />
                </Grid>

                <Grid item xs={12} sx={{ mt: 2 }}>
                  <ExplanationAccordion>Neither field is pre-populated nor required to save.</ExplanationAccordion>
                </Grid>
              </Grid>
            </DialogContent>

            <DialogActions>
              <Button color='inherit' onClick={onClose} variant='text'>
                CANCEL
              </Button>

              <LoadingButton color='primary' type='submit' loading={isSubmitting || isLoading} variant='contained'>
                Save
              </LoadingButton>
            </DialogActions>
          </form>
        )}
      </Formik>
    </Dialog>
  )
}
